import React from 'react';
import './bottom-footer.scss';
import giocaSenzaEsagerare from '../../../assets/img/footer/gioca-senza-esagerare.svg';
import vietatoMinori from '../../../assets/img/footer/vietato-minori.svg';
import ADM from '../../../assets/img/footer/adm-logo.svg';

function BottomFooter() {
  return (
    <div className='BottomFooter'>
      <div className='logos'>
        <img src={giocaSenzaEsagerare} alt='Gioca senza esagerare' className='logo'></img>
        <img src={vietatoMinori} alt='Il gioco &#232; vietato ai minori di 18 anni' className='logo'></img>
        <img src={ADM} alt='Agenzia delle Dogane e dei Monopoli' className='logo'></img>
      </div>
      <div className='infos'>
        <span>
          Consulta l&#039;<a href='https://mylotteries.it/wifi/informativa-privacy-wifi.html' target="_blank" rel="noreferrer">Informativa privacy</a> e le <a href='https://mylotteries.it/wifi/condizioni-servizio-wifi.html' target="_blank" rel="noreferrer">Condizioni Generali del Servizio</a>
        </span>

        <div className='links'>
          <a href='https://mylotteries.it/informativa-privacy-contact-center.html' target="_blank" rel="noreferrer">Informativa privacy Contact center</a>
          <a href='https://mylotteries.it/informativa-privacy-app.html' target="_blank" rel="noreferrer">Informativa privacy APP My Lotteries</a>
          {/* <a href='#' className='ot-sdk-show-settings'>Gestione Cookie</a> */}
          <a href='https://mylotteries.it/cookie-policy.html' target="_blank" rel="noreferrer">Cookie Policy</a>
        </div>
      </div>
    </div>
  );
}

export default BottomFooter;
